import 'react-app-polyfill/ie11';
import './index.css';

import { AppBugsnagErrorBoundary, leaveBreadcrumb } from 'cfa-react-logging';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { datadogLogs } from '@datadog/browser-logs';

import App from './App';
import UnrecoverableError from './components/UnrecoverableError';
import constants from './constants';
import initializeStore from './initializeStore';
import { setupAmplitude } from './services/amplitude';
import { setupLogging } from './services/logging';
import { BrowserRouter } from './util/history';
import redirectToHttpsIfNecessary from './util/redirectToHttpsIfNecessary';
import ReduxStore from './util/reduxStore';

redirectToHttpsIfNecessary({
  location: window.location,
  redirectToUrl: (url) => {
    window.location.href = url;
  },
});

const store = initializeStore();
ReduxStore.store = store;

// set up bugsnag/DataDog
setupLogging(store.getState);

datadogLogs.logger.info('Application Startup');

leaveBreadcrumb('Application Startup', {
  message: 'Application initializing',
});

setupAmplitude();

const root = createRoot(document.getElementById('root') as HTMLElement);

(async () => {
  const LDProvider = await asyncWithLDProvider(constants.LD_CONFIG);

  root.render(
    <AppBugsnagErrorBoundary FallbackComponent={UnrecoverableError}>
      <LDProvider>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </LDProvider>
    </AppBugsnagErrorBoundary>,
  );
})();
